import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { environment } from '../../../../environments/environment';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Input() isOpen: boolean = true;
  @Output() toggleSidebar = new EventEmitter<void>();
  
  appName = environment.appName;
  appSubtitle = environment.appSubtitle;

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }

  isProductDropdownOpen = false;

  menuItems: any[] = [];

  ngOnInit() {
    this.loadMenuItems();
    this.checkAndOpenDropdown();
  }

  loadMenuItems() {
    const user = this.authService.getCurrentUser();
    
    if (user?.userType === 'Supplier') {
      // Supplier menu items
      this.menuItems = [
        {
          label: 'Leads',
          icon: 'leads',
          route: '/leads',
          active: false,
          hasSubmenu: false
        },
        {
          label: 'Quotes',
          icon: 'quotes',
          route: '/quote',
          active: false,
          hasSubmenu: false
        },
        {
          label: 'Products',
          icon: 'products',
          route: '/product',
          active: false,
          hasSubmenu: false
        }
      ];
    } else {
      // Admin/Manager menu items
      this.menuItems = [
        {
          label: 'Products',
          icon: 'products',
          route: '/product',
          active: false,
          hasSubmenu: true,
          subItems: [
            { label: 'Product Category', route: '/product/category' },
            { label: 'Products', route: '/product' },
            { label: 'Add Product', route: '/product/add' }
          ]
        },
        {
          label: 'Quotes',
          icon: 'quotes',
          route: '/quote',
          active: false,
          hasSubmenu: false
        },
        {
          label: 'Suppliers',
          icon: 'suppliers',
          route: '/supplier',
          active: false,
          hasSubmenu: false
        }
      ];

      // Only Admin can access Team menu
      if (user?.userType === 'Admin') {
        this.menuItems.push({
          label: 'Team',
          icon: 'team',
          route: '/team',
          active: false,
          hasSubmenu: false
        });
      }
    }
  }

  constructor(
    public authService: AuthService,
    private router: Router
  ) {
    // Listen to route changes to auto-open dropdown if sub-item is active
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkAndOpenDropdown();
    });
  }


  checkAndOpenDropdown() {
    const productItem = this.menuItems.find(item => item.hasSubmenu);
    if (productItem && this.isSubItemActive(productItem)) {
      this.isProductDropdownOpen = true;
    }
  }

  toggleProductDropdown() {
    this.isProductDropdownOpen = !this.isProductDropdownOpen;
  }

  isSubItemActive(item: any): boolean {
    if (!item.hasSubmenu || !item.subItems) return false;
    const currentPath = window.location.pathname;
    return item.subItems.some((subItem: any) => currentPath === subItem.route || currentPath.startsWith(subItem.route + '/'));
  }

  isActiveRoute(route: string): boolean {
    // This will be handled by routerLinkActive in the template
    return false;
  }
}

